import { navigate } from "gatsby";
import React from "react";

import SubNavMenu from "../../components/shared/subNavMenu";
import Logo from "../../images/gvi-logo2.inline.svg";
import ArrowRight from "../../images/icons/arrow-right.inline.svg";
import GridDarkIcon from "../../images/icons/fi-rr-grid-dark.inline.svg";
import GridLightIcon from "../../images/icons/fi-rr-grid-light.inline.svg";

const MenuProgram = ({
  menuItems,
  menuSectionTitle,
  site,
  colorMode,
  currentBrand,
  peopleDomain,
  planetDomain,
  children
}) => {
  const secondarySiteUrl = currentBrand.includes("people")
    ? planetDomain
    : peopleDomain;

  const hasJourneysInMenu =
    process.env.GATSBY_DEFAULT_THEME === "light" ? 6 : 5;

  return (
    <section className="bg-yellow-lighter dark:bg-gray-darker fixed w-full top-16 z-10 flex justify-center py-10 h-100 md:overflow-y-scroll lg:overflow-y-hidden">
      <div className="container flex w-10/12 flex-wrap lg:flex-nowrap">
        <div className="w-full flex flex-col border-l-0 mr-12 lg:w-9/12">
          <div className="w-full flex">
            <div className="w-full border-l-0 mr-12 lg:w-8/12 ">
              <div className="w-full gvi-dark-gray-color border-b pb-3 border-border-light dark:border-gray-lighter">
                <span className="uppercase active-link !px-0 pb-3 h5">
                  {menuSectionTitle}
                </span>
              </div>
              <div className="w-full flex mt-8">
                <div className="w-6/12 flex flex-col pr-8">
                  {menuItems?.slice(0, 2).map((menu, index) => {
                    return (
                      <SubNavMenu
                        subTitle={menu.label}
                        subTitleClass={menu?.description}
                        subTitleLinkDesc={menu?.description}
                        subtitleLink={menu?.path ?? menu?.url}
                        className={menu?.cssClasses?.join(" ")}
                        data={menu?.children?.nodes ?? menu?.children}
                        key={index}
                      />
                    );
                  })}
                </div>
                <div className="w-6/12 flex flex-col">
                  {menuItems
                    ?.slice(2, hasJourneysInMenu)
                    ?.map((menu, index) => {
                      return (
                        <SubNavMenu
                          subTitle={menu.label}
                          subTitleClass={menu?.description}
                          subTitleLinkDesc={menu?.description}
                          subtitleLink={menu?.path ?? menu?.url}
                          className={menu?.cssClasses.join(" ")}
                          data={menu?.children?.nodes ?? menu?.children}
                          key={index}
                        />
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="w-full border-l-0 lg:w-4/12">
              <div className="w-full flex">
                <div className="w-full flex flex-col">
                  {menuItems?.slice(hasJourneysInMenu, 7).map((menu, index) => {
                    return (
                      <SubNavMenu
                        subTitle={menu.label}
                        subTitleClass={menu?.description}
                        subTitleLinkDesc={menu?.description}
                        subtitleLink={menu?.path ?? menu?.url}
                        subTitleLinkActive={true}
                        className={menu?.cssClasses.join(" ")}
                        data={menu?.children?.nodes ?? menu?.children}
                        key={index}
                      />
                    );
                  })}

                  <p className="text-xs text-black-lighter dark:text-white pt-8">
                    {site.siteMetadata.nav_title
                      .toLowerCase()
                      .includes("people")
                      ? "Go to GVI's conservation programs"
                      : "Go to GVI's community development programs"}
                  </p>
                  <div className="flex items-center pt-4">
                    <a
                      href={secondarySiteUrl ?? "#"}
                      className="cursor-pointer flex items-center"
                    >
                      <Logo className="w-10 fill-black-lighter dark:fill-white" />
                      <span className="text-black-lighter dark:text-white px-4 uppercase font-semibold text-xs menu-link tracking-tabheadingactive">
                        {site.siteMetadata.sec_nav_title}
                      </span>
                      <ArrowRight className="stroke-green-standard dark:stroke-red-light" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex space-between items-center py-2">
            <button
              className="flex px-8 py-2 bg-white dark:bg-gray-standard justify-center mb-6 items-center w-4/12 rounded-full dark:rounded-xxs"
              onClick={() => navigate("/find-a-program/")}
            >
              {colorMode === "light" ? <GridLightIcon /> : <GridDarkIcon />}
              <span className="pl-2 font-semibold text-base text-black-lighter dark:text-white tracking-[0.02em]">
                Find a program
              </span>
            </button>
            <div className="w-full ml-4 border-t border-border-light dark:border-gray-lighter">
              &nbsp;
            </div>
          </div>
        </div>
        <div className="w-full pt-4 pb-4 lg:pt-0 lg:w-3/12">{children}</div>
      </div>
    </section>
  );
};

export default React.memo(MenuProgram);
